module.exports = __webpack_public_path__ + "static/media/Lock-min.a74e52fd.PNG";